import Vue from 'vue';
const resource = '/ordermessages';

export default {
  // CUSTOM ENDPOINT
  getByOrder(idPublic) {
    return Vue.prototype.$axiosMainClient.get(`orders/${idPublic}${resource}`);
  },
};
